export default __webpack_public_path__ + "static/media/dashboard_icon.bc800f3b.svg";